<template>
  <div>
    <div class="content_title">
      Линии проезда
    </div>
    <div class="main">
      <div class="form-row-parse">
        <div
          class="form-input-parse"
          v-show="kpps"
          @change="changeVillage"
        >
          <label for="name-input">КПП</label>
          <select id="name-input" v-model="idKpp" @change="villageSelected">
            <option
              v-for="(kpp, key) in kpps"
              :value="kpp.ID"
              :key="key"
            >
              {{ kpp.NAME }}
            </option>
          </select>
        </div>
        <div v-show="idKpp">
          <input
            type="button"
            @click="editOngoing = true"
            value="Добавить линию проезда"
          />
        </div>
      </div>
      <div class="form-row-parse" v-show="editOngoing">
        <div>
          <label>
            Номер проезда:
            <input type="text" v-model="lineNumber" />
          </label>
        </div>
        <div>
          <label>
            Ссылка на поток камеры:
            <input type="text" v-model="lineCamera" />
          </label>
        </div>
        <div>
          <label>
            Контроллер:
            <select id="controller-input" v-model="lineController">
              <option
                v-for="(controller, key) in controllers"
                v-show="controller.FEATURE_MASK==10534921 || controller.FEATURE_MASK==10534923"
                :value="controller.ID"
                :key="key"
              >
                {{ controller.NAME }}
              </option>
            </select>
          </label>
        </div>
        <div>
          <label>
            Контроллер камеры:
            <select id="controller-camera-input" v-model="cameraController">
              <option
                v-for="(controller, key) in controllers"
                v-show="controller.FEATURE_MASK==2097216"
                :value="controller.ID"
                :key="key"
              >
                {{ controller.NAME }}
              </option>
            </select>
          </label>
        </div>
        <div>
          <button @click="addMapControls" style="width: auto">Создать границы проезда</button>
        </div>
        <div>
          <button @click="saveLine" style="width: auto">Сохранить линию</button>
        </div>
      </div>
      <div class="form-row-parse">
        <div v-show="info">{{ info }}</div>
      </div>
    </div>
    <div class="main_control_panel" v-show="showMap">
      <yandex-map
        map-type="hybrid"
        :coords="coordsCenter"
        :zoom.sync="zoom"
        :controls="[]"
        @map-was-initialized="firstMapInit"
      >
        <ymap-marker
          v-for="(item, index) in showVillageBound"
          :coords="item.coordinates"
          :marker-type="item.type"
          :properties="{ id: item.id }"
          :options="overlayVillage"
          :marker-id="index"
          v-bind:key="index + 'village'"
        />
        <ymap-marker
          v-for="(item, index) in plants"
          :coords="item.coordinates"
          :marker-type="item.type"
          :options="overlayPlant"
          :properties="{ data: item, id: item.id, delete: 'N', type: 'plot' }"
          :marker-id="index"
          :key="index + 'plant'"
        />
        <!--        <ymap-marker
          v-for="(land, index) in plotNumbers"
          :key="index + 'number'"
          :marker-id="index + 'number'"
          :coords="land.center"
          :options="land.options"
          :properties="{ type: 'number' }"
          marker-type="Placemark"
        >
        </ymap-marker>-->
      </yandex-map>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import { yandexMap, ymapMarker } from "vue-yandex-maps";

export default {
  name: "PaintAccessLineInt",
  components: { yandexMap, ymapMarker },
  data() {
    return {
      info: null,
      map: false,
      paintListeners: false,
      editOngoing: false,
      selectionMode: false,
      lineNumber: "",
      lineCamera: "",
      controllers: [],
      lineController: "",
      cameraController: "",
      selectionModeStyles: {
        strokeColor: "#ff0000",
        strokeOpacity: 0.6,
        strokeWidth: 2,
        fillColor: "#ff0000",
        fillOpacity: 0.01
      },
      plantsData: {},
      landsChoseToEdit: [],
      landsDeleted: [],
      selectElementOb: false,
      fillColor: "#307c0d",
      fillColorChosed: "#7c0d16",
      fillColorSelect: "#b9b9b9",
      idVillage: null,
      idDistrict: null,
      idRegion: null,
      idKpp: null,
      villages: [],
      districts: [],
      regions: [],
      plantsOnId: {},
      plants: [],
      zoom: 12,
      plotNumbers: false,
      plotNumbersRemoved: false,
      lineGeometries: {},
      kpps: [],
      showMap: false,
      currentPlot: {
        NUMBER: null,
        ID: null
      },
      showVillageBound: [],
      //selectVillageCenter: false,
      url: config.backend_url,
      coordsCenter: [55.755819, 37.617644],
      overlayVillage: {
        fillColor: "#7c270d",
        strokeColor: "#fcfcfc",
        fillOpacity: 0.5,
        strokeWidth: 1
      },
      overlayPlant: {
        fillColor: "#307c0d",
        strokeColor: "#fcfcfc",
        fillOpacity: 0.5,
        strokeWidth: 1
      },
      buttonSelectMode: false,
      arraySelectPlots: [],
      plotDataMultiple: {
        SERVICE_COST: null
      }
    };
  },
  computed: {
    dataSelectElement: function() {
      return this.selectElementOb
        ? this.selectElementOb.properties.get("data")
        : false;
    }
  },
  watch: {
    zoom: function(newZoom) {
      let maxZoom = 15;
      if (newZoom < maxZoom && !this.plotNumbersRemoved) {
        this.plotNumbersRemoved = true;
        //this.plotNumbers.removeFromMap(this.map);
      } else if (newZoom >= maxZoom && this.plotNumbersRemoved) {
        this.plotNumbersRemoved = false;
        //this.plotNumbers.addToMap(this.map);
      }
    }
  },
  methods: {
    villageSelected() {
      let self = this;
      let data = {
        url: self.url + "parsecterritory/get/",
        data: {},
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (!data.error) {
          self.controllers = data;
        }
      });
    },
    clickPolygon(e) {
      let element = e.get("target");
      let id = element.properties.get("id");
      this.currentPlot.ID = id;
      this.selectElementOb = element;
      element.options.set("fillColor", this.fillColorSelect);

      let objects = window.ymaps.geoQuery(this.map.geoObjects);
      let otherObjects = objects
        .search('properties.type = "plot"')
        .search("properties.id != " + id)
        .search("properties.select != 'Y'");
      otherObjects.setOptions("fillColor", this.fillColor);
    },
    closeSelectData() {
      this.selectElementOb.properties.set("selected", "N");
      this.selectElementOb.options.set("fillColor", this.fillColor);
      this.selectElementOb = false;
    },
    unselectElements() {
      let objects = window.ymaps.geoQuery(this.map.geoObjects);
      let otherObjects = objects
        .search("properties.type = 'plot'")
        .search("properties.select = 'Y'");
      otherObjects.setOptions("fillColor", this.fillColor);
      this.arraySelectPlots = [];
    },
    firstMapInit: function(map) {
      this.map = map;
      this.getRegions();
      this.idRegion = this.$route.query.region;
      if (this.idRegion) this.getDistricts();
      this.idDistrict = this.$route.query.district;
      if (this.idDistrict) this.getVillages();
      if (this.idVillage) this.villageSelected();
      setTimeout(() => {
        this.idVillage = this.$route.query.village;
        if (this.idVillage) this.showVillage();
      }, 500);
    },
    getRegions: function() {
      let self = this;
      let data = {
        url: self.url + "regions/get/",
        data: {},
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (!data.error) {
          self.regions = data;
        }
      });
    },
    getDistricts: function() {
      let self = this;
      let data = {
        url: self.url + "districts/get/",
        filter: { REGION: self.idRegion },
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (!data.error) {
          self.districts = data;
        }
      });
    },
    getVillages: function() {
      let self = this;
      let data = {
        url: self.url + "villages/get/",
        filter: { DISTRICT: self.idDistrict },
        method: "POST"
      };
      this.plants = [];
      this.$store
        .dispatch("query/sendRequest", data)
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.villages = data;
            let elementsData = [];
            for (const [key, value] of Object.entries(data)) {
              let coord = JSON.parse(value.GEO_COORD);
              let valueCoord = {};
              coord.forEach(function(val) {
                valueCoord.name = value.NAME;
                valueCoord.type = val.type;
                valueCoord.id = parseInt(key);
                valueCoord.coordinates = val.coordinates;
                elementsData.push(valueCoord);
              });
            }
            self.paintOnMap();
            self.showVillageBound = elementsData;
          }
        })
        .then(function() {
          setTimeout(function() {
            self.map.setBounds(self.map.geoObjects.getBounds(), {
              checkZoomRange: true,
              duration: 1
            });
          }, 1);
        });
    },
    addQueries: function() {
      this.$router.push({
        query: {
          village: this.idVillage,
          district: this.idDistrict,
          region: this.idRegion
        }
      });
    },
    getPolygonCentroid(arr) {
      var x = arr.map(function(a) {
        return a[0];
      });
      var y = arr.map(function(a) {
        return a[1];
      });
      var minX = Math.min.apply(null, x);
      var maxX = Math.max.apply(null, x);
      var minY = Math.min.apply(null, y);
      var maxY = Math.max.apply(null, y);
      return [(minX + maxX) / 2, (minY + maxY) / 2];
    },
    setLandsNumber() {
      //if (this.plotNumbers) this.plotNumbers.removeFromMap(this.map);
      let resultArr = {
        type: "FeatureCollection",
        features: []
      };
      let self = this;
      this.plants.forEach(function(value) {
        let coords = value.coordinates;
        let center = self.getPolygonCentroid(coords[0]);
        let number = value.data.NUMBER || "";
        let content = window.ymaps.templateLayoutFactory.createClass(
          '<div class="numbers" style="color:#ffffff;font-size:10px;">' +
            number +
            "</div>"
        );
        let result = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: center
          },
          properties: {
            ID: value.id,
            type: "landNumber"
          },
          options: {
            iconLayout: "default#imageWithContent",
            iconImageHref: "",
            hasBalloon: false,
            hasHint: false,
            zIndex: -9,
            zIndexHover: -9,
            iconImageSize: [0, 0],
            iconOffset: [-number.length * 2.5, -5],
            iconContentLayout: content
          }
        };
        if (number) resultArr.features.push(result);
      });
      this.plotNumbers = window.ymaps.geoQuery(resultArr).addToMap(this.map);
    },
    changeVillage: function() {
      this.addQueries();
      this.showVillage();
    },
    showVillage: function() {
      let self = this;
      this.showVillageBound = [];
      this.plants = [];
      var village = Object.keys(self.kpps[self.idKpp].VILLAGES)[0];

      let data = {
        url: self.url + "plots/get/",
        filter: { VILLAGE: village },
        method: "POST"
      };
      this.$store
        .dispatch("query/sendRequest", data)
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            let elementsData = [];
            self.plantsOnId = data;
            for (const [key, value] of Object.entries(data)) {
              let coord = JSON.parse(value.COORDINATES);
              let valueCoord = {};
              valueCoord.name = value.KADASTR;
              valueCoord.type = "Polygon";
              valueCoord.id = parseInt(key);
              valueCoord.coordinates = [];
              valueCoord.coordinates.push(coord);
              valueCoord.data = value;
              elementsData.push(valueCoord);
            }
            self.plants = elementsData;
            self.setLandsNumber();
          }
        })
        .then(function() {
          setTimeout(function() {
            self.setEventsToPlots();
            self.map.setBounds(self.map.geoObjects.getBounds());
          }, 100);
        });
    },
    addMapControls: function() {
      let self = this;
      self.showMap = true;

      self.editPolygon = new window.ymaps.Polygon(
        [],
        {},
        {
          editorDrawingCursor: "crosshair",
          fillColor: "#00FF00",
          fillOpacity: 0.1,
          strokeColor: "#0000FF",
          strokeWidth: 1
        }
      );
      self.map.geoObjects.add(self.editPolygon);
      self.editPolygon.editor.startDrawing();
    },
    saveLine() {
      let self = this;
      let coordinates = self.editPolygon.geometry.getCoordinates();
      if (coordinates[0].length < 1) {
        alert("Нужно разметить границы линии");
      } else {
        let saveData = {};
        saveData.type = "Polygon";
        saveData.coordinates = coordinates;
        self.editPolygon.editor.stopEditing();
        self.lineGeometries = saveData;
        console.log(saveData);
        self.editOngoing = false;
        self.showMap = false;

        let data = {
          url: self.url + "accesslines/add/",
          data: {
            NUMBER: self.lineNumber,
            COORDINATES: coordinates,
            CAMERA: self.lineCamera,
            CONTROLLER: self.lineController,
            CAMERA_CONTROLLER: self.cameraController,
            KPP_ID: self.idKpp
          },
          method: "POST"
        };
        this.$store
          .dispatch("query/sendRequest", data)
          .then(function(response) {
            let data = response.data;
            if (data.error) {
              self.info = data.error;
            } else {
              console.log(data);
            }
            self.waite = false;
          });
      }
    },
    paintOnMap() {
      window.ymaps.modules.define(
        "ext.paintOnMap",
        ["meta", "util.extend", "pane.EventsPane", "Event"],
        function(provide, meta, extend, EventsPane, Event) {
          "use strict";

          // zIndex пейна событий карты по умолчанию равен 500.
          // Подробней в документации: https://tech.yandex.ru/maps/doc/jsapi/2.1/ref/reference/map.pane.Manager-docpage/
          var EVENTS_PANE_ZINDEX = 500;

          var DEFAULT_UNWANTED_BEHAVIORS = ["drag", "scrollZoom"];
          var DEFAULT_STYLE = {
            strokeColor: "#0000ff",
            strokeWidth: 1,
            strokeOpacity: 1
          };
          var DEFAULT_TOLERANCE = 16;

          var badFinishPaintingCall = function() {
            throw new Error(
              "(ymaps.ext.paintOnMap) некорректный вызов PaintingProcess#finishPaintingAt. Рисование уже завершено."
            );
          };

          /**
           * @interface ymaps.ext.paintOnMap.PaintingProcess
           */

          /**
           * Отключает режим рисования.
           * @function
           * @name ymaps.ext.paintOnMap.PaintingProcess#finishPaintingAt
           * @param {Number[]|ymaps.Event} [positionOrEvent] Координаты точки, в которой рисование должно закончиться.
           * Координаты задаются в пикселях относительно верхнего левого угла карты.
           * @return {Number[]} Координаты.
           */

          /**
           * Включает режим рисования.
           * @name ymaps.ext.paintOnMap
           * @param {ymaps.Map} map
           * @param {Number[]|ymaps.Event} [positionOrEvent] Координаты точки, в которой рисование должно закончиться.
           * Координаты задаются в пикселях относительно верхнего левого угла карты.
           * @param {Object} [config]
           * @param {String[]|null} [config.unwantedBehaviors] Список поведений карты, которые должны быть выключены во время
           * рисования. Перетаскивание карты и её масштабирование колесом мыши выключены по умолчанию.
           * @param {Object} [config.style] Стили такие же, как в ymaps.Polygon или ymaps.Polyline.
           * @param {String} [config.style.strokeColor='#0000ff'] Цвет линии или обводки.
           * @param {Number} [config.style.strokeWidth=1] Толщина линии или обводки.
           * @param {Number} [config.style.strokeOpacity=1] Прозрачность линии или обводки.
           * @param {Number} [config.tolerance=16] Уровень упрощения координат в пикселях.
           * @returns {ymaps.ext.paintOnMap.PaintingProcess} Процесс рисования.
           */
          function paintOnMap(map, positionOrEvent, config) {
            config = config || {};
            var style = extend(DEFAULT_STYLE, config.style || {});

            var unwantedBehaviors =
              config.unwantedBehaviors === undefined
                ? DEFAULT_UNWANTED_BEHAVIORS
                : config.unwantedBehaviors;

            var pane = new EventsPane(map, {
              css: { position: "absolute", width: "100%", height: "100%" },
              zIndex: EVENTS_PANE_ZINDEX + 50,
              transparent: true
            });

            map.panes.append("ext-paint-on-map", pane);

            if (unwantedBehaviors) {
              map.behaviors.disable(unwantedBehaviors);
            }

            // Создаём canvas-элемент.
            var canvas = document.createElement("canvas");
            var ctx2d = canvas.getContext("2d");
            var rect = map.container.getParentElement().getBoundingClientRect();
            canvas.width = rect.width;
            canvas.height = rect.height;

            ctx2d.globalAlpha = style.strokeOpacity;
            ctx2d.strokeStyle = style.strokeColor;
            ctx2d.lineWidth = style.strokeWidth;

            canvas.style.width = "100%";
            canvas.style.height = "100%";

            pane.getElement().appendChild(canvas);

            var firstPosition = positionOrEvent
              ? toPosition(positionOrEvent)
              : null;
            var coordinates = firstPosition ? [firstPosition] : [];

            var bounds = map.getBounds();
            var latDiff = bounds[1][0] - bounds[0][0];
            var lonDiff = bounds[1][1] - bounds[0][1];

            canvas.onmousemove = function(e) {
              coordinates.push([e.offsetX, e.offsetY]);

              ctx2d.clearRect(0, 0, canvas.width, canvas.height);
              ctx2d.beginPath();

              ctx2d.moveTo(coordinates[0][0], coordinates[0][1]);
              for (var i = 1; i < coordinates.length; i++) {
                ctx2d.lineTo(coordinates[i][0], coordinates[i][1]);
              }

              ctx2d.stroke();
            }.bind(this);

            // Создаём косвенное обращение, чтобы не сдерживать сборщик мусора.
            var paintingProcess = {
              finishPaintingAt: function(positionOrEvent) {
                paintingProcess.finishPaintingAt = badFinishPaintingCall;

                // Получаем координаты, прежде чем удалить пейн.
                if (positionOrEvent) {
                  coordinates.push(toPosition(positionOrEvent));
                }

                map.panes.remove(pane);
                if (unwantedBehaviors) {
                  map.behaviors.enable(unwantedBehaviors);
                }

                var tolerance =
                  config.tolerance === undefined
                    ? DEFAULT_TOLERANCE
                    : Number(config.tolerance);
                if (tolerance) {
                  coordinates = simplify(coordinates, tolerance);
                }
                // Преобразовываем координаты canvas-элемента в геодезические координаты.
                return coordinates.map(function(x) {
                  var lon = bounds[0][1] + (x[0] / canvas.width) * lonDiff;
                  var lat = bounds[0][0] + (1 - x[1] / canvas.height) * latDiff;

                  return meta.coordinatesOrder === "latlong"
                    ? [lat, lon]
                    : [lon, lat];
                });
              }
            };

            return paintingProcess;
          }

          function toPosition(positionOrEvent) {
            return positionOrEvent instanceof Event
              ? [positionOrEvent.get("offsetX"), positionOrEvent.get("offsetY")]
              : positionOrEvent;
          }

          function simplify(coordinates, tolerance) {
            var toleranceSquared = tolerance * tolerance;
            var simplified = [coordinates[0]];

            var prev = coordinates[0];
            for (var i = 1; i < coordinates.length; i++) {
              var curr = coordinates[i];
              if (
                Math.pow(prev[0] - curr[0], 2) +
                  Math.pow(prev[1] - curr[1], 2) >
                toleranceSquared
              ) {
                simplified.push(curr);
                prev = curr;
              }
            }

            return simplified;
          }

          provide(paintOnMap);
        }
      );
    },
    paintProcessClose() {
      this.selectionMode = false;
      this.paintListeners.removeAll();
      this.unselectElements();
    },
    paintMouseUp(e) {
      let self = this;
      if (this.paintProcess) {
        let objects = window.ymaps.geoQuery(self.map.geoObjects);
        let coordinates = this.paintProcess.finishPaintingAt(e);
        this.paintProcess = null;

        let geoObject = !self.buttonSelectMode.isSelected()
          ? new window.ymaps.Polygon(
              [coordinates],
              {},
              self.selectionModeStyles
            )
          : new window.ymaps.Polyline(
              coordinates,
              {},
              self.selectionModeStyles
            );

        self.map.geoObjects.add(geoObject);

        let objectsInside = objects
          .searchIntersect(geoObject)
          .search('properties.type="plot"');

        objectsInside.each(function(plot) {
          let id = plot.properties.get("id");
          self.arraySelectPlots.push(id);
          //console.log(self.plantsOnId[id]);
        });

        objectsInside.setOptions("fillColor", "#416bff");
        objectsInside.setProperties("select", "Y");

        self.map.geoObjects.remove(geoObject);
      }
    },
    paintMouseDown(e) {
      let self = this;
      if (e.get("altKey")) {
        this.paintProcess = window.ymaps.ext.paintOnMap(self.map, e, {
          style: self.selectionModeStyles
        });
      }
    },
    paintProcess() {
      let self = this;
      this.selectionMode = true;
      window.ymaps
        .ready(["ext.paintOnMap"])
        .then(function() {
          self.paintListeners = self.map.events
            .group()
            .add("mousedown", self.paintMouseDown)
            .add("mouseup", self.paintMouseUp);
        })
        .catch(console.error);
    },
    setEventsToPlots() {
      let objects = window.ymaps.geoQuery(this.map.geoObjects);
      let plots = objects.search('properties.type="plot"');

      plots.addEvents("click", this.clickPolygon);
      plots.addEvents("contextmenu", this.removeSingleSelect);
    },
    removeSingleSelect(e) {
      if (this.selectionMode) {
        let element = e.get("target");
        let id = element.properties.get("id");
        let index = this.arraySelectPlots.indexOf(id);
        if (index > -1) {
          this.arraySelectPlots.splice(index, 1);
        }
        element.options.set("fillColor", this.fillColor);
      }
    },
    getKpps: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "kpp/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.kpps = data;
          }
        });
    }
  },
  created() {
    this.getKpps();
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(value, null, 2);
    }
  }
};
</script>
